<template>
  <div class="terms-component pa-2 mx-2">
    <v-card-title class="pt-6 font-weight-bold">{{
      $t('terms.audio.recordingLawsNotice')
    }}</v-card-title>
    <div>
      <v-card-text style="min-height: 300px">
        <p>
          {{ $t('terms.audio.vigilCloudAudio1') }}
          ("{{ $t('terms.audio.recordingLaws') }}")
          {{ $t('terms.audio.vigilCloudAudio2') }}
        </p>
        <v-checkbox
          v-if="!termsPage"
          v-show="!userClickOpen"
          primary
          hide-details
          type="checkbox"
          :input-value="termsAgreed"
          @click="acceptTerms"
          class="ml-5"
          :label="agreeText"
          name="eula-accept-checkbox"
        >
        </v-checkbox>
      </v-card-text>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AudioComponent',
  props: {
    termsAgreed: {
      type: Boolean,
      required: true,
    },
    termsPage: {
      type: Boolean,
      required: false,
    },
    userClickOpen: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    acceptTerms() {
      this.$emit('acceptTerms', !this.termsAgreed)
    },
  },
  computed: {
    agreeText() {
      return this.$t('terms.audio.iHaveReviewed')
    },
  },
  mounted() {
    this.$vuetify.goTo('.terms-component', {
      container: '.text-card',
      duration: 0,
    })
  },
})
</script>

<style lang="scss">
.terms-component {
  .link {
    color: #0091ff;
    &:hover {
      color: white;
    }
  }
}
</style>
